import { render, staticRenderFns } from "./wyModalAddIntervention.vue?vue&type=template&id=24bb8fee&"
import script from "./wyModalAddIntervention.vue?vue&type=script&lang=js&"
export * from "./wyModalAddIntervention.vue?vue&type=script&lang=js&"
import style0 from "./wyModalAddIntervention.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports